import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { OrganisationSearchModel } from '../../Models/Models/Customer/OrganisationSearch/OrganisationSearchModel';
import { CustomerStatus } from '../../Constants/Enums/Domain/CustomerStatus';
import { CustomerType } from '../../Constants/Enums/Customer/CustomerType';
import { FATCABusinessType } from '../../Constants/Enums/Customer/FATCABusinessType';
import { CompanyType } from '../../Constants/Enums/Customer/CompanyType';
import { RoleType } from '../../Constants/Enums/RoleType';
import { EntityType } from '../../Constants/Enums/EntityType';

declare var IS_RUNNING_IN_APP_POOL;

export class OrganisationSearchClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(organisationId: number, organisationStatus: CustomerStatus, customerType: CustomerType, businessType: FATCABusinessType, companyType: CompanyType, organisationName: string, isPartialOrganisationName: boolean, clAccountId: string, organisationRole: RoleType, entityType: EntityType, entityId: number, visibleToAdviserId: number, currentPage: number, pageSize: number): Promise<OrganisationSearchModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/OrganisationSearch/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { organisationId: organisationId, organisationStatus: organisationStatus, customerType: customerType, businessType: businessType, companyType: companyType, organisationName: organisationName, isPartialOrganisationName: isPartialOrganisationName, clAccountId: clAccountId, organisationRole: organisationRole, entityType: entityType, entityId: entityId, visibleToAdviserId: visibleToAdviserId, currentPage: currentPage, pageSize: pageSize }

    return AjaxWrapper.get<OrganisationSearchModel, any>(url, data);
  }
}

